module.exports = __webpack_public_path__ + "img/sankaku_92_red.b002e36f.png";